const SalesAnalyticsSkeleton = () => (
  <div className="skeleton-section-card">
    <div className="skeleton" style={{ height: 20, width: 200, marginBottom: 16 }} />
    <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: 30, width: 100 }} />
      ))}
    </div>
    <div className="skeleton skeleton-chart" />
  </div>
);

export default SalesAnalyticsSkeleton;
